import React from 'react';
import { ApplicationConfigForm } from '../design_page';

import {
    Products,
    ImageAd,
    Nav,
    NoticeBar,
    SearchBar,
    Showcase,
    ProductCard,
    LandscapeImage,
    StaticPicture,
    AdPlayer,
    ImageNav,
    ShopWindow,
    Banner,
    CommodityTab,
    HotZone,
    PointSwap,
    PointsDisplay,
    NoticeBarTransverse,
    ProductCardSPU,
} from '../design_page';

// 积分商品选择
const pointCustomSelectorConfig = {
    // 商品多选弹窗配置
    multiProduct: {
        contentConfig: {
            entity: 'product',
            content: {
                items: [
                    {
                        params: {
                            type: 'FK_POINTS',
                        },
                        fields: [
                            // {
                            //     property: 'showName'
                            // },
                            {
                                property: 'sku',
                            },
                            {
                                property: 'name',
                            },
                        ],
                    },
                    {
                        params: {
                            type: 'FK_POINTS',
                        },
                        columns: [
                            {
                                property: 'sku',
                                width: 200,
                            },
                            {
                                property: 'name',
                                width: 200,
                            },
                            {
                                property: 'brand',
                                width: 150,
                            },
                            // {
                            //     property: 'levelList',
                            //     width: 100,
                            // }
                        ],
                    },
                ],
            },
        },
        modalConfig: {
            title: '请选择积分商品',
            destroyOnClose: true,
        },
    },
};
export const customSelectorConfig = {
    // 商品单选弹窗配置
    singleProduct: {
        contentConfig: {
            entity: 'product',
            content: {
                items: [
                    {
                        fields: [
                            {
                                property: 'sku',
                            },
                            {
                                property: 'name',
                            },
                        ],
                    },
                    {
                        columns: [
                            {
                                property: 'sku',
                                width: 200,
                            },
                            {
                                property: 'name',
                                width: 200,
                            },
                            {
                                property: 'brand',
                                width: 200,
                            },
                        ],
                    },
                ],
            },
        },
        modalConfig: {
            title: '请选择商品',
            destroyOnClose: true,
        },
    },

    // 商品多选弹窗配置
    multiProduct: {
        contentConfig: {
            entity: 'product',
            content: {
                items: [
                    {
                        fields: [
                            {
                                property: 'salesTag',
                                controlConfig: {
                                    style: { width: '160px' },
                                },
                            },
                            // {
                            //     property: 'showName'
                            // },
                            {
                                property: 'sku',
                            },
                            {
                                property: 'name',
                            },
                        ],
                    },
                    {
                        columns: [
                            {
                                property: 'sku',
                                width: 220,
                            },
                            {
                                property: 'name',
                                width: 220,
                            },
                            {
                                property: 'brand',
                                width: 200,
                            },
                            // {
                            //     property: 'levelList',
                            //     width: 100,
                            // }
                        ],
                    },
                ],
            },
        },
        modalConfig: {
            title: '请选择商品',
            destroyOnClose: true,
        },
    },

    topic: {
        contentConfig: {
            content: {
                items: [
                    {
                        params: {
                            enabled: true,
                        },
                        fields: [
                            {
                                property: 'name',
                                label: '名称',
                            },
                        ],
                    },
                    {
                        params: {
                            enabled: true,
                        },
                        columns: [
                            {
                                property: 'name',
                                width: 400,
                            },
                            {
                                property: 'createTime',
                                width: 200,
                            },
                        ],
                    },
                ],
            },
        },
        modalConfig: {
            title: '请选择专题',
            destroyOnClose: true,
        },
    },
    customUrl: {
        modalConfig: {
            title: '请输入自定义链接',
        },
    },
};

ApplicationConfigForm.register(
    {
        name: 'products',
        render: (data: any, extra: any) => (
            <Products {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'productCard',
        render: (data: any, extra: any) => (
            <ProductCard {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'productCardSPU',
        render: (data: any, extra: any) => (
            <ProductCardSPU {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'pointSwap',
        title: '积分兑换',
        defaultConfig: {
            bgPic: '',
            pageMargin: 0,
            bgRoundedCorners: 0,
            productTab_activeTabImage: '',
            productTab_inactiveTabImage: '',
            productTab_pointsProduct: [],
            productTab_showData: ['name', 'price'],
            productTab_color: '#000',
            couponTab_activeTabImage: '',
            couponTab_inactiveTabImage: '',
            couponTab_coupons: [],
        },
        validate: (data: any) => {
            const {
                productTab_activeTabImage,
                productTab_inactiveTabImage,
                productTab_pointsProduct,
                couponTab_activeTabImage,
                couponTab_inactiveTabImage,
                couponTab_coupons,
            } = data;

            return (
                productTab_activeTabImage &&
                productTab_inactiveTabImage &&
                productTab_pointsProduct.length &&
                couponTab_activeTabImage &&
                couponTab_inactiveTabImage &&
                couponTab_coupons.length
            );
        },
        render: (data: any, extra: any) => {
            return <PointSwap {...data} {...extra} selector={pointCustomSelectorConfig} />;
        },
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'pointsDisplay',
        render: (data: any, extra: any) => (
            <PointsDisplay {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'pointProductCard',
        title: '积分商品',
        defaultConfig: {
            showStyle: '1',
            showContent: ['buy', 'name', 'price'],
            showContentBox: ['buy', 'name', 'pointPrice'],
            showContentColor: {
                pointPrice: '#8c6057',
            },
        },
        validate: (data: any) => {
            return new Promise(function(resolve) {
                resolve(data);
            });
        },
        render: (data: any, extra: any) => (
            <ProductCard {...data} {...extra} selector={pointCustomSelectorConfig} />
        ),
    },
    false
);

ApplicationConfigForm.register(
    {
        name: 'pointProducts',
        title: '积分商品(旧)',
        defaultConfig: {
            showStyle: '1',
            showContent: ['buy', 'name', 'price'],
            showContentBox: ['buy', 'name', 'pointPrice'],
            showContentColor: {
                price: '#d21820',
                marketPrice: '#d21820',
            },
        },
        validate: (data: any) => {
            return new Promise(function(resolve) {
                resolve(data);
            });
        },
        render: (data: any, extra: any) => (
            <Products {...data} {...extra} selector={pointCustomSelectorConfig} />
        ),
    },
    false
);

ApplicationConfigForm.register(
    {
        name: 'landscapeImage',
        render: (data: any, extra: any) => (
            <LandscapeImage {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'banner',
        render: (data: any, extra: any) => (
            <Banner {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'adPlayer',
        render: (data: any, extra: any) => (
            <AdPlayer {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'imageNav',
        render: (data: any, extra: any) => (
            <ImageNav {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'commodityTab',
        render: (data: any, extra: any) => (
            <CommodityTab {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'hotZone',
        render: (data: any, extra: any) => (
            <HotZone {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'shopWindow',
        render: (data: any, extra: any) => (
            <ShopWindow {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'staticPicture',
        render: (data: any, extra: any) => (
            <StaticPicture {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'imageAd',
        render: (data: any, extra: any) => (
            <ImageAd {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'nav',
        render: (data: any, extra: any) => (
            <Nav {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'noticeBar',
        render: (data: any, extra: any) => (
            <NoticeBar {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'searchBar',
        render: (data: any, extra: any) => (
            <SearchBar {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'showcase',
        render: (data: any, extra: any) => (
            <Showcase {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);

ApplicationConfigForm.register(
    {
        name: 'noticeBarTransverse',
        render: (data: any, extra: any) => (
            <NoticeBarTransverse {...data} {...extra} selector={customSelectorConfig} />
        ),
    },
    true
);
